var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"添加人员","visible":_vm.showTubeView,"width":700,"destroyOnClose":""},on:{"ok":_vm.handleOk,"cancel":_vm.closeTubeView}},[_c('a-row',{attrs:{"gutter":48}},[_c('a-col',{attrs:{"md":24,"sm":24}},[_c('a-transfer',{attrs:{"list-style":{
    width: '300px',
    height: '300px',
  },"titles":_vm.titles,"data-source":_vm.userlist,"show-search":"","filter-option":_vm.filterOption,"target-keys":_vm.targetKeys,"render":item => item.title},on:{"change":_vm.handleChange,"search":_vm.handleSearch}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }